export default "\n:where(.css-dev-only-do-not-override-1qb1s0s).ant-modal-root .ant-modal-mask {\n  z-index: 5000;\n}\n.ant-modal-wrap {\n  z-index: 5001;\n}\n"